import type { SupportCaseView, SupportOrderContext } from '@yingbaba/types';
import { digitalPurchasePath } from './digital-links';

export const supportCaseStatus: Record<string, string> = {
  new: '等待接入',
  in_progress: '处理中',
  waiting_support: '等待客服回复',
  waiting_user: '等待补充资料',
  resolved: '已处理',
};
export function supportOrderStatus(order?: SupportOrderContext) {
  if (!order) return '订单状态待核对';
  if (order.fulfillment_status === 'refunded' || order.status === 'refunded') return '已退款';
  if (order.fulfillment_status === 'fulfilled')
    return order.kind === 'digital' ? '授权已签发' : '会员开通处理完成';
  if (order.fulfillment_status === 'pending')
    return order.kind === 'digital' ? '已到账，授权处理中' : '已到账，会员开通处理中';
  if (order.fulfillment_status || order.status === 'payment_review') return '到账情况待核查';
  return (
    (
      { pending: '等待付款', paid: '已支付', cancelled: '已取消', expired: '已过期' } as Record<
        string,
        string
      >
    )[order.status] || '订单状态待核对'
  );
}
export function supportOrderURL(value: SupportCaseView) {
  if (!value.order_id) return;
  if (value.order_kind === 'member')
    return `/membership?${new URLSearchParams({ member_order: value.order_id })}`;
  if (value.order_kind === 'digital')
    return digitalPurchasePath(
      value.order_id,
      value.order_context?.owner_type || (value.organization_id ? 'organization' : 'account'),
    );
}
